import React, { useState, useEffect } from "react";
import axios from "axios";
import { Route, Link, Switch, useHistory } from "react-router-dom";
import imgA from "./img/abys_logo_top.png";
import imgB from "./img/abys_logo_bg.png";
import imgprofile from "./img/Ellipse 1.png";
import Login from "./Login";
import Logout from "./Logout";
import Content_m from "./Content_m";
import Register from "./Register";
import Complete from "./Complete";
import ServiceApply from "./ServiceApply";
import ServiceInfo from "./ServiceInfo";
import Certification from "./Certification";
import CarManagement from "./CarManagement";
import Storeinformation from "./Storeinformation";
import FindShop from "./FindShop";
import Progress from "./Progress";
import DriverInform from "./DriverInform";
import CarmasterInform from "./CarmasterInform";
import CapitalCalendar from "./CapitalCalendar";
import ReservationInfo from "./ReservationInfo";
import ReservationComplete from "./ReservationComplete";
import Mypagemain from "./Mypagemain";
import MyService from "./MyService";
import ServiceAll from "./ServiceAll";
import { instance } from "./common";
import Represent from "./Represent";
import RepInsert from "./RepInsert";
import RepCheck from "./RepCheck";
import RepFindShop from "./RepFindShop";
import RepStoreInfo from "./RepStoreInfo";
import Mypageedit from "./Mypageedit";
import RepReserve from "./RepReserve";
//import Cart from './Cart';
import Cart from "./New_Cart";
import RepCalendar from "./RepCalendar";
import InsertCar from "./InsertCar";
import MyReserve from "./MyReserve";
import NoticeList from "./NoticeList";
import FaqList from "./FaqList";
import NoticeDetail from "./NoticeDetail";
import Reserve_detail from "./Reserve_detail";
import RepReserve_detail from "./RepReserve_detail";
// import sigong_list from './Sigong_list'; // 이전 시공리스트 컴포넌트
import Sigong_list from "./components/Sigong/List"; //현캐작업하면서 새로 들어갈 시공 컴포넌트
import { Cookies } from "react-cookie";
import Footer_m from "./Footer_m";
import Test from "./Test";
import calendarchoice from "./CalendarChoice";
import Si_reserve_detail from "./Si_reserve_detail";
import S_storeSetting from "./S_storeSetting";
import CustomerInfo from "./CustomerInfo";
import Work from "./components/Sigong/Work";
import WorkDetailPage from "./WorkDetailPage";
import Month_list from "./Month_list";
import Holiday from "./Holiday";
import StoreManage from "./StoreManage";
import StoreSetting from "./StoreSetting";
import Customer_manage from "./Customer_manage";
import Progress_list from "./Progress_list";
import Allim from "./Allim";

import kakao_png from "./img/kakao_icon.png";
import Product from "./Product";
import P_cart from "./P_cart";
import Product_detail from "./Product_detail";
import OrderSheet from "./OrderSheet";
import OrderDetail from "./OrderDetail";
import ProductManage from "./ProductManage";
import OrderPage from "./OrderPage";
import Maechul from "./Maechul";
import MaechulList from "./MaechulList";
import Jungsan from "./Jungsan";
import Quality from "./Quality";
import BojungOk from "./BojungOk";
import s_FindShop from "./s_FindShop";
import MaechulSuccess from "./MaechulSuccess";

import Ksolution from "./Ksolution";
import Klist from "./Klist";
import Sungard from "./Sungard";
import SunList from "./SunList";
import Casper from "./Casper";
import Ray from "./Ray";

import imgFrameBang1 from "./img/main_img_1.jpg";
import imgFrameBang2 from "./img/main_img_2.jpg";
import imgFrameBang2_m from "./img/main_img_2_m.jpg";
import imgFrameBang3 from "./img/main_img_3.png";
import { useMediaQuery } from "react-responsive";

import casper_bg from "./img/casper_bg.png";
import ray_bg from "./img/ray_bg.png";

function Header_m() {
  const isPc = useMediaQuery({
    query: "(min-width:768px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width:767px)",
  });

  const history = useHistory();
  const cookies = new Cookies();
  const getAutoLogin = cookies.get("isAutoLogin");

  if (getAutoLogin != null) {
    const parsedStorage = window.sessionStorage.result;

    if (parsedStorage === undefined || parsedStorage == null) {
      window.sessionStorage.setItem("isLogin", true);
      window.sessionStorage.setItem("result", JSON.stringify(getAutoLogin));
    }
  }

  const loginSpan = {
    // lineHeight : "50px"
    marginTop: "15px",
    display: "block",
    color: "white",
    fontSize: "16px",
  };
  let u_type = "";
  let u_uuid = "";
  if (window.sessionStorage.result) {
    let parseSe = JSON.parse(window.sessionStorage.result);
    u_type = parseSe.u_type;
    u_uuid = parseSe.u_uuid;
  }

  const mainGo = () => {
    window.location.replace("/");
  };

  const openKakao = {
    position: "fixed",
    right: "20px",
    bottom: u_type == "시공지점" ? "90px" : "60px",
    zIndex: "1111",
    textAlign: "center",
  };

  const open_txt = {
    textShadow: "2px 2px 6px gray",
  };

  const openKakaoGo = () => {
    if (window.Android && window.Android.googlelogin) {
      window.Android.PlusFriend("_xaeDIs");
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GoogleLogin
    ) {
      let send = { channel: "_xaeDIs" };
      window.webkit.messageHandlers.PlusFriend.postMessage(send);
    } else {
      window.open("http://pf.kakao.com/_xaeDIs");
    }
  };

  const [bannerType, setBannerType] = useState("");

  console.log("bannerType : ", bannerType);
  // const absoluteCheck = {
  //     position : window.sessionStorage.result ? bannerType === '' ? 'unset' : 'absolute' : 'absolute',
  //     boxShadow : window.sessionStorage.result ? '0 0.5px 6px #d3d3d3' : 'none'
  // }

  const [bgUrl, setbgUrl] = useState([
    {
      type: "main",
      src: `url('${imgFrameBang1}')`,
    },
    {
      type: "d2c",
      src: `url('${imgFrameBang2}')`,
    },
    {
      type: "k",
      src: `url('${imgFrameBang2}')`,
    },
    {
      type: "casper",
      src: `url('${casper_bg}')`,
    },
    {
      type: "ray",
      src: `url('${ray_bg}')`,
    },
    {
      type: "sun",
      src: `url('${imgFrameBang3}')`,
    },
    {
      type: "btob",
      src: `url('${imgFrameBang2}')`,
    },
  ]);

  const goCateNext = (typed) => {
    if (typed === "d2c") {
      alert("죄송합니다.\n현대캐피탈 고객 전용 페이지 입니다.");
    } else if (typed === "k") {
      setBannerType(typed);
      history.push("/ksolution");
    } else if (typed === "sun") {
      setBannerType(typed);
      history.push("/sungard");
    } else {
      alert("준비중입니다.");
    }
  };
  console.log("bannerType : ", bannerType);
  console.log('df', window.sessionStorage.result);


  return (
    <div>
      <div style={openKakao} onClick={openKakaoGo}>
        <img src={kakao_png} style={{ width: "47px" }} />
        <br />
        <span className="font-weight-bold" style={open_txt}>
          상담신청
        </span>
      </div>
      <header id="mobile-header" className="m" style={{ position: "absolute",top:0,minHeight:'70px' }}>
        <div className="container">
          <div className="">
            <div
              className="div-wrap d-inline-block"
              style={{ marginTop: "10px" }}
            >
              {window.sessionStorage.result ? (
                <img className="m_logo" src={imgB} onClick={mainGo} />
              ) : bannerType === "" ? (
                <img className="m_logo" src={imgB} onClick={mainGo} />
              ) : (
                <img className="m_logo" src={imgA} onClick={mainGo} />
              )}
            </div>
            <div className="div-wrap d-inline-block myprofile">
              {window.sessionStorage.result ? (
                u_uuid ? (
                  <Link to="/mypagemain">
                    <img className="myprofile" src={u_uuid} />
                  </Link>
                ) : (
                  <Link to="/mypagemain">
                    <img className="myprofile" src={imgprofile} />
                  </Link>
                )
              ) : bannerType === "" ? (
                <Link to="/login" onClick={() => setBannerType('')}>
                  <span style={{ ...loginSpan, color: "#000" }}>로그인</span>
                </Link>
              ) : (
                <Link to="/login" onClick={() => setBannerType('')}>
                  <span style={loginSpan}>로그인</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>
      {bannerType === "" && <div style={{ height: "60px" }}></div>}
      {bgUrl.map(
        (v, i) =>
          v.type === bannerType && (
            <div
              className="main-top-banner"
              key={i}
              style={{ backgroundImage: v.src }}
            >
              {/* {(isMobile && bannerType === 'k') &&
                    <div className="banner-text-wrap">
                        <p className="banner-text font-weight-bold position-relative ml-4 mb-1" style={{fontSize:'20px'}}><span style={{color:'#DC1015',fontSize:'20px'}}>K</span>-Solution<span className="font-weight-normal" style={{position:'absolute',top:'-3px'}}>Premium</span></p>
                        <p className="ml-5 font-weight-bold" style={{color:'#fff',fontSize:'16px'}}>전용 프리미엄 차량관리 서비스</p>
                    </div>
                    } */}
            </div>
          )
      )}
      <Switch>
        {u_type === "시공지점" ? (
          <Route exact path="/" component={StoreManage} />
        ) : (
          <Route
            exact
            path="/"
            render={() => (
              <ServiceApply
                setBannerType={setBannerType}
                goCateNext={goCateNext}
              />
            )}
          />
        )}
        {/* <Route exact path="/" component={ServiceApply} /> */}
        {u_type === "시공지점" && (
          <Route path="/apply" component={ServiceApply} />
        )}
        <Route path="/main/:abysCategory" component={Content_m} />
        <Route
          path="/ksolution"
          render={() => <Ksolution setBannerType={setBannerType} />}
        />
        <Route
          path="/klist"
          render={() => <Klist setBannerType={setBannerType} />}
        />
        <Route
          path="/sungard"
          render={() => <Sungard setBannerType={setBannerType} />}
        />
        <Route
          path="/sunlist"
          render={() => <SunList setBannerType={setBannerType} />}
        />
        <Route
          path="/casper"
          render={() => <Casper setBannerType={setBannerType} />}
        />
        <Route
          path="/ray"
          render={() => <Ray setBannerType={setBannerType} />}
        />
        <Route path="/sigong_list" component={Sigong_list} />
        <Route path="/login" component={Login} />
        <Route path="/Logout" component={Logout} />
        <Route path="/join" component={Register} />
        <Route path="/complete" component={Complete} />
        <Route path="/service" component={ServiceInfo} />
        <Route path="/serviceAll" component={ServiceAll} />
        <Route path="/certify" component={Certification} />
        <Route path="/management" component={CarManagement} />
        <Route path="/storeinfo" component={Storeinformation} />
        <Route path="/findshop" component={FindShop} />
        <Route path="/s_findshop" component={s_FindShop} />
        <Route path="/progress" component={Progress} />
        <Route path="/driverinform" component={DriverInform} />
        <Route path="/carmaster" component={CarmasterInform} />
        <Route path="/capitalcalendar" component={CapitalCalendar} />
        <Route path="/reservationinfo" component={ReservationInfo} />
        <Route path="/resercomplete" component={ReservationComplete} />
        <Route path="/mypagemain" component={Mypagemain} />
        <Route path="/myservice" component={MyService} />
        <Route path="/represent" component={Represent} />
        <Route path="/repInsert" component={RepInsert} />
        <Route path="/repCheck" component={RepCheck} />
        <Route path="/repFindShop" component={RepFindShop} />
        <Route path="/repStoreInfo" component={RepStoreInfo} />
        <Route path="/mypageedit" component={Mypageedit} />
        <Route path="/repReserve" component={RepReserve} />
        <Route
          path="/cart"
          render={() => <Cart setBannerType={setBannerType} />}
        />
        <Route path="/repCalendar" component={RepCalendar} />
        <Route path="/insertCar" component={InsertCar} />
        <Route path="/myReserve" component={MyReserve} />
        <Route path="/noticelist" component={NoticeList} />
        <Route path="/faqlist" component={FaqList} />
        <Route path="/reserve_detail" component={Reserve_detail} />
        <Route path="/repReserve_detail" component={RepReserve_detail} />
        <Route path="/footer_m" component={Footer_m} />
        <Route path="/noticedetail" component={NoticeDetail} />
        <Route path="/test" component={Test} />
        <Route path="/calendarchoice" component={calendarchoice} />
        <Route path="/si_reserve_detail" component={Si_reserve_detail} />
        <Route path="/s_storesetting" component={S_storeSetting} />
        <Route path="/setting" component={StoreSetting} />
        <Route path="/customerinfo" component={CustomerInfo} />
        <Route path="/work" component={Work} />
        <Route path="/workdetailpage" component={WorkDetailPage} />
        <Route path="/month_list" component={Month_list} />
        <Route path="/holiday" component={Holiday} />
        <Route path="/storeManage" component={StoreManage} />
        <Route path="/customer_manage" component={Customer_manage} />
        <Route path="/progress_list" component={Progress_list} />
        <Route path="/allim" component={Allim} />
        <Route path="/product" component={Product} />
        <Route path="/product-detail" component={Product_detail} />
        <Route path="/product-cart" component={P_cart} />
        <Route path="/order-sheet" component={OrderSheet} />
        <Route path="/order-detail" component={OrderDetail} />
        <Route path="/order-page" component={OrderPage} />
        <Route path="/product-manage" component={ProductManage} />
        <Route path="/maechul" component={Maechul} />
        <Route path="/jungsan" component={Jungsan} />
        <Route path="/maechul-list" component={MaechulList} />
        <Route path="/maechul-success" component={MaechulSuccess} />
        <Route path="/quality-list" component={Quality} />
        <Route path="/bojungok" component={BojungOk} />
      </Switch>
    </div>
  );
}

export default Header_m;
